import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';
import { profileFetch } from '../models/Doctorprofile';
import { fetchAllData } from '../models/Doctor';
@Injectable({
    providedIn: 'root'
})
export class DoctorprofileService {
    constructor(
        private readonly http: HttpClient
    ) {}

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    GetAllDoctorProfiles(body: fetchAllData): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.DoctorsApi + 'fetchAll/active',
                body
            )
            .pipe(catchError(this.handleError));
    }
    getDoctorsProfileData(user_guid: string): Observable<any> {
        return this.http
            .get<any>(RestApi.Urls.DoctorsApi + 'GetForViewing/' + user_guid)
            .pipe(catchError(this.handleError));
    }

    getDoctorsProfileDataForDoctorDash(
        data: profileFetch
    ): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.DoctorsApi + 'Profile/fetch',
                data
            )
            .pipe(catchError(this.handleError));
        //return of (DOCTORS);
    }
}
